<template>
  <div>
    <van-popup v-model="showPop" round :style="{width:'90%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form
          ref="formRef"
          input-align="right" 
          validate-first 
          :show-error-message="false"
          validate-trigger="onSubmit"
          :disabled="isEdit"
        >
          <div class="field-box" v-if="awardSetType === 'global' || awardSetType == 'office'">
            <van-field 
              class="field" 
              label="名次设置" 
              v-model="prize.rankingStart" 
              input-align="center" 
              label-width="4em"
              type="digit"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入名次设置' }]"
              @blur="checkFeeValid('rankingStart')"
            >
              <span slot="right-icon">名</span>
            </van-field>
            <span>至</span>
            <van-field 
              class="field-border" 
              v-model="prize.rankingEnd" 
              input-align="center"
              type="digit"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入名次设置' }]"
              @blur="checkFeeValid('rankingEnd')"
            >
              <span slot="right-icon">名</span>
            </van-field>
          </div>
          <van-field 
            v-if="awardSetType === 'ladder' || awardSetType === 'random'"
            class="field"
            label="所需数钱次数"
            v-model="prize.countTime"
            type="digit" 
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入所需数钱次数' }]"
            @blur="checkFeeValid('countTime')"
          >
            <span slot="right-icon">次</span>
          </van-field>
          <van-field 
            class="field"
            label="奖品类型"
            readonly
            v-model="prizeType" 
            right-icon="arrow"
            placeholder="请选择"
            @click="prizeTypeChange"
          />
          <van-field 
            v-if="awardSetType=== 'random'" 
            class="field"
            :disabled="false"
            label="中奖概率" 
            v-model="prize.probability" 
            type="number"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入中奖概率' }]"
            @blur="checkGit('probability')"
          >
            <span slot="right-icon">%</span>
          </van-field>
          <template v-if="prize.prizeType === 'award'">
            <van-field 
              class="field" 
              label="奖品名称" 
              v-model="prize.prizeName" 
              :maxlength="10" 
              name="prizeName"
              placeholder="请输入" 
              :rules="[{ required: true, message: '请输入奖品名称' }]"
            />
            <van-field 
              class="field" 
              label="奖品总份数"
              v-if="awardSetType !== 'encourage'" 
              v-model="prize.prizeCount" 
              type="digit" 
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入奖品总份数' }]"
              @blur="checkFeeValid('prizeCount')"
            >
              <span slot="right-icon">份</span>
            </van-field>
            <van-field class="field" label="奖品图片上传" v-model="prize.prizeImg">
              <template #input>
                <van-uploader
                  :disabled="isEdit"
                  :max-count="1"
                  result-type="file"
                  :before-read="beforeImgUpload" 
                  :after-read="uploadImg"
                  :fileList="imgList"
                  @delete="deleteImg"
                />
              </template>
            </van-field>
          </template>
          <template v-if="prize.prizeType === 'coupon'">
            <van-field 
              class="field" 
              label="优惠券名称" 
              v-model="prize.prizeName"
              :maxlength="10" 
              placeholder="请输入" 
              :rules="[{ required: true, message: '请输入优惠券名称' }]"
            />
            <van-field 
              class="field" 
              label="优惠券内容" 
              v-model="prize.couponContent" 
              :maxlength="20"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入优惠券内容' }]"
            />
            <van-field
              v-if="awardSetType !== 'encourage'"
              class="field" 
              label="优惠券总份数" 
              v-model="prize.prizeCount" 
              type="digit" 
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入优惠券总份数' }]"
              @blur="checkFeeValid('prizeCount')"
            >
              <span slot="right-icon">份</span>
            </van-field>
            <van-field 
              class="field" 
              v-model="prize.couponIndate" 
              label-width="8em"
              type="digit" 
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入优惠券有效期' }]"
              @blur="checkFeeValid('couponIndate')"
            >
              <div slot="label">
                <span>优惠券有效期</span>
                <van-icon class="icon" name="question" @click="toast('ladder')"/>
              </div>
              <span slot="right-icon">天</span>
            </van-field>
          </template>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="save">保存 </div>
        </div>
      </div>
    </van-popup>
    <van-action-sheet
      v-model="isPrizeSelect"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      get-container="body"
      @cancel="cancelSelect"
      @select="confirmSelect"
    />
    <van-popup v-model="isOverlay" :style="{width:'100%'}" :close-on-click-overlay="false" get-container="body">
      <div class="cropper">
        <h5-cropper ref="cropper" :option="option" @getFile="getFile" @canceltailor="canceltailor"></h5-cropper>
      </div>
    </van-popup>
  </div>
</template>

<script>
import H5Cropper  from 'vue-cropper-h5'
import { round2Places } from "@/utils/utils";
export default {
  components: { H5Cropper },
  props: {
    isShowPrizePop: {
      type: Boolean,
      default: false
    },
    awardSetType: {
      type: String,
      default: ''
    },
    prize: {
      type: Object,
      default() {
        return {}
      }
    },
    rankRange: {
      type: Array,
      default() {
        return []
      }
    },
    globalCurrentIndex: {
      type: Number,
      default: 0
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prizeType: '奖品',
      isPrizeSelect: false,
      actions: [
        {name: '奖品',type: 'award'},
        {name: '优惠券(线下)',type: 'coupon'},
      ],
      imgList: [],
      option: {
        ceilbutton: true
      },
      isOverlay: false,
    }
  },
  computed: {
    showPop: {
      get() {
        return this.isShowPrizePop
      },
      set(newVal) {
        this.$emit('update:isShowPrizePop', newVal)
      }
    },
  },
  watch: {
    showPop: {
      handler(newVal) {
        if (newVal) {
          if (this.prize.prizeImg) {
            this.imgList= [{url: this.prize.prizeImg}]
          }else {
            this.imgList = []
          }
        }
      },
      deep: true,
    },
    isShowPrizePop: {
      handler(newVal) {
        if (newVal) {
          this.prizeType =  this.prize.prizeType === 'coupon' ? '优惠券(线下)' : '奖品'
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    cancel() {
      this.showPop = false
      this.resetForm()
    },
    resetForm() {
      for(let [key,value] of Object.entries(this.prize)) {
        this.prize[key] = ''
      }
      this.prizeType = '奖品'
      this.prize.prizeType = 'award'
    },
    save() {
      this.$refs.formRef.validate()
        .then(res => {
          if (this.awardSetType == 'global' || this.awardSetType == 'office') {
            const isPass = this.checkoutRankInterval()
            if (!isPass) return
          }
          if (this.imgList.length) {
            this.prize.prizeImg = this.imgList[0].url || ''
            this.imgList = []
          } else {
            this.prize.prizeImg = ''
          }
          this.$emit('prizeSaveSuccess', {...this.prize}, this.awardSetType)
          this.$toast('保存成功')
          this.showPop = false
          this.resetForm()
        })
        .catch(err => {
          this.$toast(err[0].message)
        })
    },
    checkoutRankInterval() {
      let isPass = true
      const {rankingStart,rankingEnd} = this.prize
      if (rankingStart > rankingEnd-0) {
        this.$toast('开始名次不能大于结束名次')
        isPass = false
        return
      } 
      if (this.rankRange.length) {
        let next = this.rankRange[this.globalCurrentIndex-1]
        let last = this.rankRange[this.globalCurrentIndex+1]
        if (next && rankingStart-0 <= next.end ) {
          isPass = false
          this.$toast(`开始名次不能小于等于${next.end}`)
        } else if (last && rankingEnd-0 >= last.start ) {
          isPass = false
          this.$toast(`结束名次不能大于等于${last.start}`)
        }
      }
      return isPass
    },
    cancelSelect() {
      this.isPrizeSelect = false
    },
    confirmSelect(obj) {
      const { name, type } = obj
      this.prize.prizeType = type
      this.prizeType = name
    },
    prizeTypeChange() {
      if (this.isEdit) return
      this.isPrizeSelect = true
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e) {
      this.isOverlay = true
      this.$emit("changFoot", false)
      this.$nextTick(()=> {
        this.$refs.cropper.loadFile(e.file)
      })
    },
    getFile(file) {
      this.$emit("changFoot", true)
      this.isOverlay = false
      this.imgList = [{
        url: '',
        status: 'uploading',
        message: '上传中...',
      }]
      this.$api.common.uploadImg(file)
        .then(res => {
          if (res.data && res.data[0]) {
            this.imgList[0].url = res.data[0].fileUrl
            this.imgList[0].status = 'done'
          }
        }).catch(err => {
          this.imgList[0].status = 'failed'
          this.imgList[0].message = '上传失败'
        })
    },
    deleteImg() {
      this.imgList = []
    },
    canceltailor() {
      this.isOverlay = false
    },
    checkFeeValid(fieldName) {
      let fieldValue = this.prize[fieldName];
      if (fieldName != 'prizeCount'&& fieldValue > 999) {
        fieldValue = 999
      } else if (fieldName == 'prizeCount' && fieldValue > 999999) {
        fieldValue = 999999
      } 
      this.prize[fieldName] = round2Places(fieldValue)
    },
    checkGit() {
      let { probability } = this.prize
      if (probability < 0.001) {
        probability = 0.001
      } else if (probability > 100) {
        probability = 100
      }
      this.prize.probability = round2Places(probability,3)
    },

    toast() {
      this.$toast({
        message: '优惠券的使用时效，从领取当日计算',
        duration: 3000
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    // height: 100px;
    .field-box {
      display: flex;
      align-items: center;
      justify-content: center;
      .field {
        width: 520px;
      }
      .field-border {
        padding-right: 0;
        margin-right: 16px;
        border-bottom: 1px solid #ebedf0;
      }
    }
    .icon {
      margin-left: 4px;
    }
    .img-box {
      width: 80px;
      height: 80px;
      background: #ccc;
    }
    .footer {
      box-sizing: border-box
      display: flex
      align-items: center
      justify-content: space-around
      padding-bottom constant(safe-area-inset-bottom)
      padding-bottom env(safe-area-inset-bottom)
      margin: 10px;
      border-bottom-left-radius: 16px
      border-bottom-right-radius: 16px
      background-color #fff
      .button {
        padding 10px 40px
        border 1px solid $mainTextColor
        border-radius: 8px
        color #fff
        background-color: $mainTextColor
      }
      .cancel {
        color $mainTextColor
        background: #fff;
      }
    }
  }
  .cropper {
    height: 100vh;
  }
</style>